export let props = ['dialogVisible', 'title', 'width']
export let model = {
    test: true,
}
export let computed = {
    _dialogVisible: {
        get () {
            return this.dialogVisible
        },
        set (val) {
            this.$emit('update:dialogVisible', val)
        }
    },
}